export default __webpack_public_path__ + "static/IN-8015_2-8mm_lense_day_zoom-9f1590c9811ce9e8f54465c7327dcbe0.webp";